import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ME_Fit } from 'me-fit-typings';

@Component({
  selector: 'me-exercise-video',
  templateUrl: './exercise-video.component.html',
  styleUrls: ['./exercise-video.component.css']
})
export class ExerciseVideoComponent implements OnInit {

  @Input() video: ME_Fit.ExerciseVideo;

  @Input() controls = true;

  @Input() autoplay = false;

  @Output() loadingChange = new EventEmitter<boolean>();

  totalVideoRetries = 0;

  constructor() { }

  ngOnInit() {
    // Emit initial loading state
    this.setLoadingState(true);
  }

  private setLoadingState(loading: boolean) {
    this.loadingChange.emit(loading);
  }

  onVideoLoadStart() {
    this.setLoadingState(true);
  }

  onVideoCanPlay() {
    this.setLoadingState(false);
  }

  videoErrorLoad(e: Event) {
    // We dont want to retry video loading after 5 times.
    if (this.totalVideoRetries > 5 ) {
      this.setLoadingState(false);
      return;
    }

    setTimeout(() => {
      // If video loading fails, re-try in 1 second.
      (e.target as HTMLVideoElement).load();
      this.totalVideoRetries++;
    }, 1000);
  }
}
